import { render, staticRenderFns } from "./HeaderBand.vue?vue&type=template&id=8d7468a2&scoped=true&"
import script from "./HeaderBand.vue?vue&type=script&lang=js&"
export * from "./HeaderBand.vue?vue&type=script&lang=js&"
import style0 from "./HeaderBand.vue?vue&type=style&index=0&id=8d7468a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d7468a2",
  null
  
)

export default component.exports